import createSelector from "../../utils/reselect";

const clientsStateData = (state) => {
  const { clients } = state;
  return clients || {};
};

export const client = createSelector(clientsStateData, (clients) =>
  clients.get("client")
);

export const clients = createSelector(clientsStateData, (clients) =>
  clients.get("clients")
);

export const loading = createSelector(clientsStateData, (clients) =>
  clients.get("loading")
);

export const loader = createSelector(clientsStateData, (clients) =>
  clients.get("loader")
);

export const overviewLoader = createSelector(clientsStateData, (clients) =>
  clients.get("overviewLoader")
);

export const clientsPagination = createSelector(clientsStateData, (clients) =>
  clients.get("clientPagination")
);

export const getError = createSelector(clientsStateData, (clients) =>
  clients.get("error")
);

///////////////////////////////////////////////// PORTFOLIOS /////////////////////////////////////////////////

export const portfolio = createSelector(clientsStateData, (clients) =>
  clients.get("portfolio")
);

export const portfolios = createSelector(clientsStateData, (clients) =>
  clients.get("portfolios")
);

export const portfoliosPagination = createSelector(
  clientsStateData,
  (clients) => clients.get("portfoliosPagination")
);

///////////////////////////////////////////////// PORTFOLIOS /////////////////////////////////////////////////

export const resources = createSelector(clientsStateData, (clients) =>
  clients.get("resources")
);

export const resourcesPagination = createSelector(clientsStateData, (clients) =>
  clients.get("resourcesPagination")
);

///////////////////////////////////////////////// PROGRAM /////////////////////////////////////////////////

// export const programs = createSelector(clientsStateData, (clients) => clients.get("programs"));

// export const programsLoading = createSelector(clientsStateData, (clients) => clients.get("programsLoading"));

// export const programsPagination = createSelector(clientsStateData, (clients) => clients.get("programsPagination"));
